<template>
  <detail-row-wrapper :save-function="update" :cancel-function="cancel">
    <div class="contents-wrapper">
      <div class="main-contents">
        <detail-row-component title="종류" :inner-vertical="true">
          <layout-radio-button v-model="editable.type" :name="`type${rowIndex}`"
            :select-list="['레드', '화이트', '스파클링', '로제', '위스키', '맥주', '사케']"
            :view-list="['레드', '화이트', '스파클링', '로제', '위스키', '맥주', '사케']" />

          <!-- <layout-blank :value="12" />
					<layout-info title="* 색상 표기가 꺼져있으면 보이지 않습니다." />
					<layout-info title="ex) 색상 표기 ON  스파클링 ON : 레드, 스파클링" />
					<layout-info title="ex) 색상 표기 OFF 스파클링 ON : 스파클링" /> -->
        </detail-row-component>
        <detail-row-component title="공급자">
          <layout-auto-complete v-model="editable.supplierId" api-url="/api/suppliers" :http-options="httpOptions"
            track-name="name" track-by="id" place-holder="공급자를 검색해서 선택하세요." :callback="selectSupplier"
            :regex="regex(1, 10000).ko_en_num" />
        </detail-row-component>
        <detail-row-component title="공급 준비 일자 (Default)">
          <layout-input v-model="editable.supplierDefaultPrepareDays" placeholder="공급 준비 일자를 입력해주세요"
            :regex="regex(0, 30).num" type="number" disabled />
        </detail-row-component>

        <detail-row-component title="생산자">
          <layout-auto-complete v-model="editable.wineryId" api-url="/api/wineries" :http-options="httpOptions"
            track-name="name" track-by="id" place-holder="생산자를 검색해서 선택하세요." :regex="regex(1, 10000).ko_en_num" />
        </detail-row-component>

        <!-- <detail-row-component title="생산자 영문 표시">
					<layout-checkbox v-model="editable.isWineryNameEnDisplay" />
				</detail-row-component> -->

        <detail-row-component title="지역">
          <layout-auto-complete v-model="editable.regionId" api-url="/api/regions" :http-options="httpOptions"
            track-name="name" track-by="id" place-holder="지역을 검색해서 선택하세요." :regex="regex(1, 10000).ko_en_num" />
        </detail-row-component>

        <detail-row-component title="와인 이름(한글)" :inner-vertical="true">
          <layout-input v-model="editable.wineName" placeholder="한글 이름을 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="와인 이름(영문)" :inner-vertical="true">
          <layout-input v-model="editable.wineNameEn" placeholder="영문 이름을 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="짧은 와인 이름">
          <layout-input v-model="editable.shortWineName" placeholder="짧은 와인 이름을 입력해주세요." />
        </detail-row-component>

        <!-- <detail-row-component title="빈티지">
					<layout-input
						v-model="editable.vintageYear"
						placeholder="빈티지를 입력해 주세요."
						:regex="regex(0, 4).num"
					/>
				</detail-row-component> -->

        <detail-row-component title="빈티지">
          <layout-input v-model="editable.vintageYear" placeholder="빈티지를 입력해 주세요." hint="NV는 입력을 하지 않습니다." />
        </detail-row-component>

        <detail-row-component title="와인리스트용 간단한 설명">
          <layout-input v-model="editable.wineDscShort" placeholder="와인 한줄 설명을 입력하세요." />
        </detail-row-component>

        <detail-row-component title="병 이미지" innerVertical>
          <layout-image-selector v-model="editable.imgBottle" :index="`image_bottle${rowData.id}`"
            :on-image-out-of-size="onImageOutOfSize" />
          <layout-blank :value="8" />
          <layout-info title="* 병 이미지 사이즈 : 1440 X 2560" infoType="warn" />
        </detail-row-component>

        <detail-row-component title="WP 점수">
          <layout-input v-model="editable.winepoint" placeholder="0~5.0 사이의 점수를 입력해주세요." :regex="regex(1, 3).num_dot"
            type="number" isFloat />
        </detail-row-component>

        <detail-row-component title="가격">
          <layout-input v-model="editable.price" placeholder="가격을 입력해주세요." :regex="regex(4, 8).num" type="number" />
        </detail-row-component>

        <detail-row-component title="발행">
          <div v-if="isHaveInventory">
            <layout-switch-button ref="submit" v-model="editable.isChecked" />
            <!-- <p>{{ editable.inventoryState }}</p> -->
            <layout-info v-if="!editable.inventoryState.isAvailable"
              title="inventory에 활성화(isAvailable) 되어 있지 않음. 와인 리스트에서 보이지 않음." />
            <layout-info :title="`재고가 ${editable.inventoryState.remaining} 남았습니다.`" />
            <layout-button-text title="인벤토리 정보 갱신" :callback="refreshInventoryState" :isType="1" />
          </div>
          <div v-else>
            <layout-info title="주문 어드민의 재고 리스트에 해당 와인이 없습니다. 재고를 등록해주신 후 발행해주세요." />
            <layout-button-text title="인벤토리 정보 갱신" :callback="refreshInventoryState" :isType="1" />
          </div>
        </detail-row-component>
      </div>
    </div>
  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from "@/utils/utils"

import DetailRowWrapper from "@/spa/components/detail-row/DetailRowWrapper"
import DetailRowComponent from "@/spa/components/detail-row/DetailRowComponent"

import LayoutRadioButton from "@/spa/components/LayoutRadioButton"
import LayoutAutoComplete from "@/spa/components/LayoutAsyncAutoComplete"
import LayoutInput from "@/spa/components/LayoutInput"
import LayoutCheckbox from "@/spa/components/LayoutCheckbox"
import LayoutSwitchButton from "@/spa/components/LayoutSwitchButton"
import LayoutImageSelector from "@/spa/components/LayoutImageSelector"
import LayoutInfo from "@/spa/components/LayoutInfo"
import LayoutBlank from "@/spa/components/LayoutBlank"
import LayoutButtonText from "@/spa/components/LayoutButtonText"

export default {
  name: "WineEditor",
  components: {
    LayoutBlank,
    LayoutRadioButton,
    LayoutAutoComplete,

    LayoutCheckbox,
    LayoutInput,
    LayoutSwitchButton,
    LayoutImageSelector,
    LayoutInfo,
    LayoutButtonText,

    DetailRowWrapper,
    DetailRowComponent
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    httpOptions() {
      return { headers: { Authorization: this.$store.getters.getToken } }
    },
    isHaveInventory() {
      return this.editable.inventoryState.isHave
    },
    isActivatedInventory() {
      return this.editable.inventoryState.isAvailable
    }
  },
  async mounted() {
    await this.refreshInventoryState()
  },
  methods: {
    async refreshInventoryState() {
      this.editable.inventoryState = await this.$store.dispatch(
        "isCheckWineToInventory",
        this.rowData
      )
    },

    onImageOutOfSize() {
      this.$toast("사이즈가 4메가가 넘습니다.")
    },

    regex(min, max) {
      return regex(min, max)
    },

    async uploadImage(image) {
      if (!image) return null
      if (typeof image === "string") return image

      console.log("imageUploadS3")
      const result = await this.$store.dispatch("imageUploadS3", {
        name: "bottles",
        image
      })

      if (!result.response) return image
      this.$toast(result.message)
      this.$toast("데이터베이스 업로드 작업중 입니다. 조금만 기다려주세요.")

      return result.response.location
    },

    async update() {
      this.editable.id = this.rowData.id
      this.editable.isOmitType = !this.editable.isOmitType
      this.editable.imgBottle = await this.uploadImage(this.editable.imgBottle)
      this.editable.vintageYear = parseInt(this.editable.vintageYear, 10)

      const validateResult = multipleValidate([
        validate({ message: "색상", target: this.editable.type }),
        validate({
          message: "와이너리 아이디",
          target: this.editable.wineryId,
          regex: this.regex(1, 200).num
        }),
        validate({
          message: "공급자 아이디",
          target: this.editable.supplierId,
          regex: this.regex(1, 200).num
        }),
        validate({
          message: "지역 아이디",
          target: this.editable.regionId,
          regex: this.regex(1, 200).num
        }),
        // validate({
        //   message: "와인 이름",
        //   target: this.editable.wineName,
        //   regex: this.regex(2, 100).ko_num
        // }),
        validate({
          message: "와인 영어 이름",
          target: this.editable.wineNameEn,
          regex: this.regex(2, 100).en_num
        }),
        // validate({
        // 	message: "빈티지",
        // 	target: this.editable.vintageYear,
        // 	// regex: this.regex(0, 4).num || this.editable.vintageYear == null
        // 	// exception: () => {
        // 	// 	console.log("isNV:", this.editable.isNV);
        // 	// 	// 이거 검증 로직을 진짜 헷갈리게 짰네.
        // 	// 	return this.editable.isNV == true;
        // 	// }
        // }),
        validate({
          message: "와인포인트",
          target: this.editable.winepoint,
          regex: this.regex(1, 3).num_dot
        }),
        validate({
          message: "가격",
          target: this.editable.price,
          regex: this.regex(4, 8).num
        })
      ])
      if (this.editable.isChecked && validateResult.flag) {
        this.$toast(validateResult.message)
        return
      }

      const result = await this.$store.dispatch("updateWine", this.editable)

      if (result.response) {
        this.$table.updateField()
      }

      this.$toast(result.message)
    },
    selectSupplier(supplier) {
      this.editable.supplierDefaultPrepareDays = supplier.prepare_days
    },
    cancel() {
      this.$table.updateField()
    }
  },
  data() {
    return {
      editable: {
        type: this.rowData.type || "레드",
        wineName: this.rowData.wine_name || null,
        wineNameEn: this.rowData.wine_name_en || null,
        vintageYear: this.rowData.vintage_year || null,
        shortWineName: this.rowData.short_wine_name || null,
        regionId: this.rowData.region_id || null,
        wineryId: this.rowData.winery_id || null,
        supplierId: this.rowData.supplier_id || null,
        supplierDefaultPrepareDays:
          this.rowData.supplier_default_prepare_days || null,
        wineDscShort: this.rowData.wine_dsc_short || null,
        imgBottle: this.rowData.img_bottle || null,
        winepoint: this.rowData.winepoint || null,
        price: this.rowData.price || null,
        isChecked: this.rowData.is_checked || false,
        inventoryState: {
          isHave: false,
          isAvailable: false,
          remaining: 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: 600px;

  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  flex-direction: row;

  .main-contents {
    position: relative;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;

    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/wine/product/detail-row/WineEditor.vue